module.exports = {
  'en': {
    'HRMS55XC1': {
      '0': 'Employee leave details',
      '10': 'Employee Code',
      '20': 'or Department',
      '30': 'From Date',
      '40': 'To',
      '50': 'Type Of Leave'
    },
    'HRMS55XC2': {
      '10': 'Employee Code',
      '20': 'Employee Name',
      '30': 'Working Date',
      '40': 'Shift Code',
      '50': 'Time In - Out',
      '60': 'Leave Code',
      '70': 'Leave Description',
      '80': 'Duration of Leave',
      '90': 'Hours of leave',
      '100': 'Request Status'
    }
  },
  'th': {
    'HRMS55XC1': {
      '0': 'รายละเอียดการลาหยุดงานของพนักงาน',
      '10': 'รหัสพนักงาน',
      '20': 'หรือ หน่วยงาน',
      '30': 'ตั้งแต่วันที่',
      '40': 'ถึง',
      '50': 'ประเภทการลาที่ต้องการสอบถาม'
    },
    'HRMS55XC2': {
      '10': 'รหัสพนักงาน',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่ทำงาน',
      '40': 'รหัสกะ',
      '50': 'เวลาเข้า-ออก',
      '60': 'รหัสการลาหยุดงาน',
      '70': 'รายละเอียดรหัสการลา',
      '80': 'ระยะเวลาที่ขอลา',
      '90': 'ชั่วโมงลา',
      '100': 'สถานะคำร้อง'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms55x.js